(() => {
  const pageRoot = document.querySelector('[data-wishlist-page]');
  if (!pageRoot) return;

  const statusEl = pageRoot.querySelector('[data-wishlist-page-status]');
  const gridEl = pageRoot.querySelector('[data-wishlist-page-grid]');
  const countEl = document.querySelector('[data-wishlist-page-count]');
  const refreshButton = document.querySelector('[data-wishlist-page-refresh]');
  const cardTemplate = document.querySelector('[data-wishlist-card-template]');
  const wishlistStorageKey = 'blue_rose_wishlist';
  const wishlistProductsCacheKey = 'blue_rose_wishlist_products_cache_v2';
  const wishlistProductsCacheTtl = 5 * 60 * 1000;

  const escapeHtml = (value) => String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const wishlistIconMarkup = `
    <span data-wishlist-icon-off class="inline-flex h-6 w-6 items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="h-6 w-6 fill-current" aria-hidden="true"><path d="M442.9 144C415.6 144 389.9 157.1 373.9 179.2L339.5 226.8C335 233 327.8 236.7 320.1 236.7C312.4 236.7 305.2 233 300.7 226.8L266.3 179.2C250.3 157.1 224.6 144 197.3 144C150.3 144 112.2 182.1 112.2 229.1C112.2 279 144.2 327.5 180.3 371.4C221.4 421.4 271.7 465.4 306.2 491.7C309.4 494.1 314.1 495.9 320.2 495.9C326.3 495.9 331 494.1 334.2 491.7C368.7 465.4 419 421.3 460.1 371.4C496.3 327.5 528.2 279 528.2 229.1C528.2 182.1 490.1 144 443.1 144zM335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1C576 297.7 533.1 358 496.9 401.9C452.8 455.5 399.6 502 363.1 529.8C350.8 539.2 335.6 543.9 320 543.9C304.4 543.9 289.2 539.2 276.9 529.8C240.4 502 187.2 455.5 143.1 402C106.9 358.1 64 297.7 64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1L320 171.8L335 151.1z"/></svg>
    </span>
    <span data-wishlist-icon-on class="hidden h-6 w-6 items-center justify-center">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="h-6 w-6 fill-current" aria-hidden="true"><path d="M305 151.1L320 171.8L335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1L576 231.7C576 343.9 436.1 474.2 363.1 529.9C350.7 539.3 335.5 544 320 544C304.5 544 289.2 539.4 276.9 529.9C203.9 474.2 64 343.9 64 231.7L64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1z"/></svg>
    </span>
  `;

  const pendingRemovalTimers = new Map();

  const getLocalWishlistIds = () => {
    try {
      const stored = window.localStorage.getItem(wishlistStorageKey);
      const parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed.map(String).filter(Boolean) : [];
    } catch (_error) {
      return [];
    }
  };

  const readProductsCache = () => {
    try {
      const raw = window.sessionStorage.getItem(wishlistProductsCacheKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.products) || !Array.isArray(parsed.ids) || !parsed.cachedAt) {
        return null;
      }
      if (Date.now() - Number(parsed.cachedAt) > wishlistProductsCacheTtl) {
        window.sessionStorage.removeItem(wishlistProductsCacheKey);
        return null;
      }
      return parsed;
    } catch (_error) {
      return null;
    }
  };

  const writeProductsCache = (ids, products) => {
    try {
      window.sessionStorage.setItem(wishlistProductsCacheKey, JSON.stringify({
        ids: ids.map(String),
        products,
        cachedAt: Date.now(),
      }));
    } catch (_error) {
      // noop
    }
  };

  const formatMoney = (amount, currencyCode) => {
    if (!amount || !currencyCode) return '';

    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: currencyCode,
      }).format(Number(amount));
    } catch (_error) {
      return `${amount} ${currencyCode}`;
    }
  };

  const refreshCartOverlayFallback = (cart) => {
    const overlay = document.querySelector('[data-cart-overlay]');
    if (!overlay) return;

    const formatCartMoney = (cents) => new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format((Number(cents) || 0) / 100);

    const countBadge = overlay.querySelector('.cart-overlay__panel .text-sm.font-semibold');
    if (countBadge) {
      countBadge.textContent = `(${cart.item_count})`;
    }

    document.querySelectorAll('[ref="cartBubbleCount"]').forEach((el) => {
      el.textContent = cart.item_count;
    });

    const scrollArea = overlay.querySelector('.flex-1.overflow-y-auto');
    if (!scrollArea) return;

    if (!cart.item_count) {
      scrollArea.innerHTML = '<p class="text-gray-600">Your cart is empty</p>';
      return;
    }

    const itemsHtml = cart.items.map((item, index) => `
      <div class="flex items-start gap-4 py-4" data-cart-line-item data-cart-item-key="${escapeHtml(item.key)}">
        <a href="${escapeHtml(item.url || '#')}" class="h-16 w-16 flex-shrink-0 overflow-hidden rounded border border-gray-200 bg-white">
          ${item.featured_image?.url ? `<img src="${escapeHtml(item.featured_image.url)}" alt="${escapeHtml(item.title)}" class="h-full w-full object-cover" loading="lazy">` : ''}
        </a>
        <div class="flex-1">
          <a href="${escapeHtml(item.url || '#')}" class="block text-sm font-semibold text-[#2b5a9b]">${escapeHtml(item.product_title || item.title || 'Cart item')}</a>
          <div class="text-sm text-gray-600">Qty: ${item.quantity}</div>
        </div>
        <div class="flex items-start gap-3">
          <button type="button" class="cursor-pointer text-[#d93b11] text-lg font-bold leading-none hover:text-[#b93210]" aria-label="Remove" data-cart-remove-line="${index + 1}" data-cart-remove-key="${escapeHtml(item.key)}">&times;</button>
          <div class="text-sm font-semibold text-gray-800">${formatCartMoney(item.final_line_price)}</div>
        </div>
      </div>
    `).join('');

    scrollArea.innerHTML = `
      <div class="divide-y divide-gray-300">${itemsHtml}</div>
      <div class="flex items-center justify-between pt-4 text-sm font-semibold text-gray-800">
        <span>Estimated Total:</span>
        <span>${formatCartMoney(cart.total_price)}</span>
      </div>
    `;
  };

  const addToCart = async (variantId, button) => {
    if (!variantId) {
      throw new Error('This item is unavailable for cart right now.');
    }

    const normalizedVariantId = String(variantId).match(/\/ProductVariant\/(\d+)$/)?.[1] || String(variantId).trim();

    const originalLabel = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding...';
    }

    const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

    try {
      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: normalizedVariantId,
          quantity: 1,
        }),
      });
      const added = await addResponse.json();
      if (added.status) {
        throw new Error(added.message || 'Could not add item');
      }

      if (window.oaiq) oaiq('measure', 'custom', { type: 'custom' }, { custom_event_name: 'add-to-cart' });

      await wait(250);

      const cart = await fetch(`/cart.js?ts=${Date.now()}`, {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        cache: 'no-store',
      }).then((response) => response.json());
      const overlay = document.querySelector('[data-cart-overlay]');
      if (overlay) {
        overlay.dataset.source = 'wishlist-page';
      }

      if (typeof window.refreshCartOverlay === 'function') {
        window.refreshCartOverlay(cart);
      } else {
        refreshCartOverlayFallback(cart);
      }

      if (window.innerWidth < 768 && typeof window.brpShowAddedBar === 'function') {
        window.__brpLastAdd = null;
        window.brpShowAddedBar(cart);
        return;
      }
      if (typeof window.openCartOverlay === 'function') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (window.scrollY === 0) {
          window.openCartOverlay();
        } else {
          window.addEventListener('scrollend', () => window.openCartOverlay(), { once: true });
        }
      } else {
        const cartTrigger = document.getElementById('cart-quickview');
        if (!cartTrigger) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        if (window.scrollY === 0) {
          cartTrigger.click();
        } else {
          window.addEventListener('scrollend', () => cartTrigger.click(), { once: true });
        }
      }
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
    }
  };

  const renderEmptyState = () => {
    gridEl.innerHTML = '';
    gridEl.classList.add('hidden');
    statusEl.classList.remove('hidden');
    statusEl.innerHTML = `
      <div class="border border-dotted border-[#c9d8e6] p-8 md:p-12 text-center bg-white">
        <div class="mx-auto mb-5 flex h-16 w-16 items-center justify-center bg-[#f2f7fb] text-[#00538d]">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" class="h-8 w-8 fill-current"><path d="M442.9 144C415.6 144 389.9 157.1 373.9 179.2L339.5 226.8C335 233 327.8 236.7 320.1 236.7C312.4 236.7 305.2 233 300.7 226.8L266.3 179.2C250.3 157.1 224.6 144 197.3 144C150.3 144 112.2 182.1 112.2 229.1C112.2 279 144.2 327.5 180.3 371.4C221.4 421.4 271.7 465.4 306.2 491.7C309.4 494.1 314.1 495.9 320.2 495.9C326.3 495.9 331 494.1 334.2 491.7C368.7 465.4 419 421.3 460.1 371.4C496.3 327.5 528.2 279 528.2 229.1C528.2 182.1 490.1 144 443.1 144zM335 151.1C360 116.5 400.2 96 442.9 96C516.4 96 576 155.6 576 229.1C576 297.7 533.1 358 496.9 401.9C452.8 455.5 399.6 502 363.1 529.8C350.8 539.2 335.6 543.9 320 543.9C304.4 543.9 289.2 539.2 276.9 529.8C240.4 502 187.2 455.5 143.1 402C106.9 358.1 64 297.7 64 229.1C64 155.6 123.6 96 197.1 96C239.8 96 280 116.5 305 151.1L320 171.8L335 151.1z"/></svg>
        </div>
        <p class="text-2xl text-[#202c3e] mb-3">Your wishlist is empty.</p>
        <p class="text-sm text-gray-500 max-w-xl mx-auto mb-6">
          Save your favorite pieces so they stay easy to find the next time you visit.
        </p>
        <a href="/collections/all" class="inline-flex items-center justify-center bg-[#00538d] hover:bg-[#006dc5] text-white uppercase tracking-wide text-sm font-medium px-6 py-3 rounded-sm transition">
          Explore all products
        </a>
      </div>
    `;
    if (countEl) countEl.textContent = '0 items';
  };

  const buildProductCard = (product, backInStockRecords = []) => {
    if (!(cardTemplate instanceof HTMLTemplateElement)) {
      return null;
    }

    const fragment = cardTemplate.content.cloneNode(true);
    const article = fragment.querySelector('article');
    if (!article) return null;

    const wishlistButton = article.querySelector('[data-wishlist-toggle]');
    const cardLinks = article.querySelectorAll('[data-wishlist-card-link], [data-wishlist-card-title-link]');
    const image = article.querySelector('[data-wishlist-card-image]');
    const imagePlaceholder = article.querySelector('[data-wishlist-card-image-placeholder]');
    const vendor = article.querySelector('[data-wishlist-card-vendor]');
    const title = article.querySelector('[data-wishlist-card-title]');
    const productCode = article.querySelector('[data-wishlist-card-product-code]');
    const reviewBadge = article.querySelector('[data-wishlist-card-review-badge]');
    const price = article.querySelector('[data-wishlist-card-price]');
    const addToCartButton = article.querySelector('[data-wishlist-add-to-cart]');
    const waitlistForm = article.querySelector('[data-wishlist-waitlist-form]');
    const removeButton = article.querySelector('[data-wishlist-remove]');

    if (wishlistButton) {
      wishlistButton.dataset.wishlistProductId = product.id;
      wishlistButton.dataset.wishlistDeferredRemove = 'true';
      wishlistButton.innerHTML = wishlistIconMarkup;
    }

    cardLinks.forEach((link) => {
      link.href = product.url || '#';
    });

    if (image) {
      if (product.imageUrl) {
        image.src = product.imageUrl;
        image.alt = product.imageAlt || product.title;
        image.classList.remove('hidden');
        imagePlaceholder?.classList.add('hidden');
      } else {
        image.classList.add('hidden');
        imagePlaceholder?.classList.remove('hidden');
      }
    }

    if (vendor) {
      if (product.vendor) {
        vendor.textContent = product.vendor;
        vendor.classList.remove('hidden');
      } else {
        vendor.classList.add('hidden');
      }
    }

    if (title) {
      title.textContent = product.title;
    }

    if (productCode) {
      if (product.productCode) {
        productCode.textContent = `Product Code: ${product.productCode}`;
        productCode.classList.remove('hidden');
      } else {
        productCode.classList.add('hidden');
      }
    }

    if (reviewBadge) {
      if (product.reviewBadge) {
        reviewBadge.innerHTML = product.reviewBadge;
        reviewBadge.classList.remove('hidden');
      } else {
        reviewBadge.classList.add('hidden');
      }
    }

    if (price) {
      const formattedPrice = product.price ? formatMoney(product.price, product.currencyCode) : '';
      if (formattedPrice) {
        price.textContent = formattedPrice;
        price.classList.remove('hidden');
      } else {
        price.classList.add('hidden');
      }
    }

    if (addToCartButton) {
      addToCartButton.dataset.wishlistVariantId = product.variantId || '';
      const canAddToCart = Boolean(product.variantId && product.availableForSale);
      addToCartButton.disabled = !canAddToCart;
      addToCartButton.textContent = canAddToCart ? 'Add to cart' : 'Unavailable';
      addToCartButton.classList.toggle('hidden', !canAddToCart);
    }

    if (waitlistForm) {
      const isOutOfStock = !product.availableForSale;
      const numericVariantId = String(product.variantId || '').match(/\/ProductVariant\/(\d+)$/)?.[1] || '';
      const waitlistSku = product.sku || (numericVariantId ? `variant:${numericVariantId}` : '');
      const waitlistStatusEl = waitlistForm.querySelector('[data-waitlist-status]');
      const waitlistPromptEl = waitlistForm.querySelector('[data-waitlist-prompt]');
      const waitlistInputRowEl = waitlistForm.querySelector('[data-waitlist-input-row]');

      const matchedRecord = (isOutOfStock && backInStockRecords.length)
        ? backInStockRecords.find((record) => {
            const recordSku = String(record.sku || '').trim();
            return (product.sku && recordSku === product.sku) ||
                   (numericVariantId && recordSku === `variant:${numericVariantId}`);
          })
        : null;

      if (matchedRecord) {
        waitlistForm.classList.remove('hidden');
        let statusText = "You’re on the list — we’ll email you when it’s back.";
        if (matchedRecord.alertStatus === 'notified' && matchedRecord.notifiedAt) {
          try {
            const notifiedDate = new Date(matchedRecord.notifiedAt);
            const formatted = notifiedDate.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
            statusText = `Notified on ${formatted}`;
          } catch (_error) {
            statusText = 'You were notified about this item';
          }
        }
        if (waitlistStatusEl) {
          waitlistStatusEl.textContent = statusText;
          waitlistStatusEl.classList.remove('hidden');
        }
        if (waitlistPromptEl) waitlistPromptEl.classList.add('hidden');
        if (waitlistInputRowEl) waitlistInputRowEl.classList.add('hidden');
      } else {
        const shouldShowWaitlist = Boolean(isOutOfStock && waitlistSku);
        waitlistForm.classList.toggle('hidden', !shouldShowWaitlist);
        window.BlueRoseStockState?.updateWaitlistForm(waitlistForm, {
          productHandle: product.handle || '',
          productTitle: product.title || '',
          productUrl: product.url || '',
          productImage: product.imageUrl || '',
          variant: {
            id: product.variantId || '',
            sku: waitlistSku,
            available: false,
          },
        });
      }
    }

    if (removeButton) {
      removeButton.dataset.wishlistProductId = product.id;
    }

    return article;
  };

  const renderProducts = (products, backInStockRecords = []) => {
    if (!products.length) {
      renderEmptyState();
      return;
    }

    gridEl.innerHTML = '';
    const productCards = products
      .map((product) => buildProductCard(product, backInStockRecords))
      .filter(Boolean);

    gridEl.append(...productCards);

    gridEl.classList.remove('hidden');
    statusEl.classList.add('hidden');
    if (countEl) {
      countEl.textContent = `${products.length} item${products.length === 1 ? '' : 's'}`;
    }
  };

  const renderCachedProducts = () => {
    const cached = readProductsCache();
    if (!cached?.products?.length) return false;

    const localIds = getLocalWishlistIds();
    const idsToRender = (localIds.length ? localIds : cached.ids).map(String);
    const cachedById = new Map(cached.products.map((product) => [String(product.id), product]));
    const products = idsToRender.map((id) => cachedById.get(id)).filter(Boolean);

    if (!products.length) return false;

    renderProducts(products);
    statusEl.classList.add('hidden');
    return true;
  };

  const fetchProducts = async (ids) => {
    const query = encodeURIComponent(ids.join(','));
    const response = await fetch(`/apps/wishlist/products?ids=${query}`, {
      headers: {
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
    });

    const payload = await response.json();

    if (!response.ok || payload.ok === false) {
      throw new Error(payload.error || `Failed to load wishlist products (${response.status})`);
    }

    return Array.isArray(payload.items) ? payload.items : [];
  };

  const fetchBackInStockItems = async () => {
    try {
      const response = await fetch('/apps/wishlist/back-in-stock/items', {
        headers: {
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
      });
      if (!response.ok) return [];
      const payload = await response.json();
      if (!payload.ok) return [];
      const waiting = Array.isArray(payload.waitingItems) ? payload.waitingItems : (Array.isArray(payload.items) ? payload.items : []);
      const notified = Array.isArray(payload.notifiedItems) ? payload.notifiedItems : [];
      return [...waiting, ...notified];
    } catch (_error) {
      return [];
    }
  };

  const refreshPage = async () => {
    try {
      const renderedFromCache = renderCachedProducts();
      if (!renderedFromCache) {
        statusEl.classList.remove('hidden');
        statusEl.textContent = 'Loading your wishlist...';
        gridEl.classList.add('hidden');
      }

      if (!window.BlueRoseWishlist?.initializeWishlist) {
        throw new Error('Wishlist is not initialized.');
      }

      await window.BlueRoseWishlist.initializeWishlist();
      const ids = window.BlueRoseWishlist.getWishlist();

      if (!ids.length) {
        renderEmptyState();
        return;
      }

      const [products, backInStockRecords] = await Promise.all([
        fetchProducts(ids),
        fetchBackInStockItems(),
      ]);
      renderProducts(products, backInStockRecords);
      writeProductsCache(ids, products);
      window.BlueRoseWishlist.syncWishlistButtons(gridEl);
    } catch (error) {
      gridEl.innerHTML = '';
      gridEl.classList.add('hidden');
      statusEl.classList.remove('hidden');
      statusEl.innerHTML = `
        <div class="border border-dotted border-gray-300 p-8 text-center bg-[#fafafa]">
          <p class="text-lg text-[#202c3e] mb-2">We couldn't load your wishlist.</p>
          <p class="text-sm text-gray-500">${escapeHtml(error.message || 'Please try again.')}</p>
        </div>
      `;
    }
  };

  const cancelQueuedRemoval = (productId) => {
    const pendingRemoval = pendingRemovalTimers.get(productId);
    if (!pendingRemoval) return false;

    window.clearTimeout(pendingRemoval.timerId);
    pendingRemovalTimers.delete(productId);

    const { article, button, banner } = pendingRemoval;
    button.setAttribute('aria-pressed', 'true');
    button.setAttribute('aria-label', 'Remove from wishlist');

    const offIcon = button.querySelector('[data-wishlist-icon-off]');
    const onIcon = button.querySelector('[data-wishlist-icon-on]');
    if (offIcon && onIcon) {
      offIcon.classList.remove('inline-flex');
      offIcon.classList.add('hidden');
      onIcon.classList.remove('hidden');
      onIcon.classList.add('inline-flex');
    }

    banner?.remove();
    article.classList.remove('opacity-0', 'transition-opacity', 'duration-500');

    return true;
  };

  const queueRemoval = (button) => {
    const productId = String(button?.dataset.wishlistProductId || '').trim();
    const article = button?.closest('article');
    if (!productId || !article) return;
    if (cancelQueuedRemoval(productId)) return;

    article.classList.add('relative', 'overflow-hidden');

    const offIcon = button.querySelector('[data-wishlist-icon-off]');
    const onIcon = button.querySelector('[data-wishlist-icon-on]');
    if (offIcon && onIcon) {
      offIcon.classList.remove('hidden');
      offIcon.classList.add('inline-flex');
      onIcon.classList.remove('inline-flex');
      onIcon.classList.add('hidden');
    }
    button.setAttribute('aria-pressed', 'false');
    button.setAttribute('aria-label', 'Add to wishlist');

    let banner = article.querySelector('[data-wishlist-remove-banner]');
    if (!banner) {
      banner = document.createElement('div');
      banner.setAttribute('data-wishlist-remove-banner', '');
      banner.className = 'absolute left-10 right-10 top-14 z-10 flex items-center justify-center opacity-96 bg-white px-4 py-3 text-center text-sm font-medium uppercase tracking-wide text-[#d93b11] shadow-sm transition-opacity duration-500';
      banner.textContent = 'Item will be removed from Wishlist';
      article.appendChild(banner);
    }

    const timerId = window.setTimeout(() => {
      banner.classList.add('opacity-0');
      article.classList.add('opacity-0', 'transition-opacity', 'duration-500');

      window.setTimeout(() => {
        void window.BlueRoseWishlist.setWishlistProductState(productId, false).then(() => {
          pendingRemovalTimers.delete(productId);
          void refreshPage();
        }).catch((error) => {
          pendingRemovalTimers.delete(productId);
          banner.remove();
          article.classList.remove('opacity-0', 'transition-opacity', 'duration-500');
          window.alert(error.message || 'We could not remove this item from your wishlist.');
        });
      }, 500);
    }, 3000);

    pendingRemovalTimers.set(productId, { timerId, article, button, banner });
  };

  document.addEventListener('DOMContentLoaded', () => {
    void refreshPage();
  });

  document.addEventListener('click', (event) => {
    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      const productId = removeButton.dataset.wishlistProductId;
      if (productId && window.BlueRoseWishlist?.setWishlistProductState) {
        void window.BlueRoseWishlist.setWishlistProductState(productId, false).then(() => {
          void refreshPage();
        }).catch((error) => {
          window.alert(error.message || 'We could not remove this item from your wishlist.');
        });
      }
      return;
    }

    const addToCartButton = event.target.closest('[data-wishlist-add-to-cart]');
    if (addToCartButton) {
      void addToCart(addToCartButton.dataset.wishlistVariantId, addToCartButton).catch((error) => {
        window.alert(error.message || 'We could not add this item to your cart.');
      });
      return;
    }

    if (event.target.closest('[data-wishlist-toggle]')) {
      const wishlistButton = event.target.closest('[data-wishlist-toggle]');
      if (wishlistButton?.dataset.wishlistDeferredRemove === 'true') {
        queueRemoval(wishlistButton);
      } else {
        window.setTimeout(() => {
          void refreshPage();
        }, 150);
      }
    }
  });

  if (refreshButton) {
    refreshButton.addEventListener('click', () => {
      void refreshPage();
    });
  }

  window.addEventListener('storage', () => {
    void refreshPage();
  });
})();
